// Compact change-kind glyph rendered as the leftmost cell in review-mode
// rows. + (add) / Δ (edit) / − (remove). Empty placeholder for unchanged
// rows so columns still align.
import { cn } from "@/utils/cn";

export type ChangeKind = "add" | "edit" | "remove";

type ChangeSymbolProps = {
  kind: ChangeKind | null;
};

export function ChangeSymbol({ kind }: ChangeSymbolProps) {
  if (!kind) return <span className="af-sym af-sym-empty" />;
  const glyph = kind === "add" ? "+" : kind === "remove" ? "−" : "Δ";
  const label =
    kind === "add"
      ? "Added by AI"
      : kind === "remove"
      ? "Removed by AI"
      : "Concentration edited by AI";
  return (
    <span
      className={cn("af-sym", `af-sym-${kind}`)}
      title={label}
      aria-label={label}
    >
      {glyph}
    </span>
  );
}
